import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ChartThemeProperty } from '@nimbus-library/features/charts/models/chart-theme-property.enum';

export enum HistoryConversationStatus {
  VoiceMessage = 'VoiceMessage',
  HangupBeforeAccept = 'HangupBeforeAccept',
  HangupInIvr = 'HangupInIvr',
  HangupInQueue = 'HangupInQueue',
  HangupByWorkflow = 'HangupByWorkflow',
  CustomerHangupInIvrAfterQueue = 'CustomerHangupInIvrAfterQueue',
  AcceptedByUser = 'AcceptedByUser',
  TransferredByWorkflow = 'TransferredByWorkflow',
  TransferredByUser = 'TransferredByUser',
  TransferFailed = 'TransferFailed',
  Failed = 'Failed',
  OutboundTaskDestinationAccepted = 'OutboundTaskDestinationAccepted',
  OutboundTaskDestinationDeclined = 'OutboundTaskDestinationDeclined',
  OutboundTaskUserAborted = 'OutboundTaskUserAborted',
  OutboundTaskDestinationNotReached = 'OutboundTaskDestinationNotReached',
  OutboundTaskLostInQueue = 'OutboundTaskLostInQueue',
  ExternalSystemCancelled = 'ExternalSystemCancelled',
  ExternalSystemCancelledAfterQueue = 'ExternalSystemCancelledAfterQueue',
  ExternalSystemCancelledBeforeAccept = 'ExternalSystemCancelledBeforeAccept',
  ExternalSystemCancelledInQueue = 'ExternalSystemCancelledInQueue',
  MarkedAsHandledByUser = 'MarkedAsHandledByUser',
  MarkedAsHandledByWorkflow = 'MarkedAsHandledByWorkflow',
  StandbyDutyExternalAccepted = 'StandbyDutyExternalAccepted',
  WorkflowCallbackScheduleSuccessful = 'WorkflowCallbackScheduleSuccessful',
}

export enum ServerSideOutcome {
  Handled = 'Handled',
  WorkflowInternalTransferFailed = 'WorkflowInternalTransferFailed',
  WorkflowExternalTransferFailed = 'WorkflowExternalTransferFailed',
  WorkflowInternalTransferSuccessful = 'WorkflowInternalTransferSuccessful',
  WorkflowExternalTransferSuccessful = 'WorkflowExternalTransferSuccessful',
  WorkflowConversationRecorded = 'WorkflowConversationRecorded',
  DeclinedByWorkflowWhenNoQueue = 'DeclinedByWorkflowWhenNoQueue',
  DeclinedByWorkflowAfterQueue = 'DeclinedByWorkflowAfterQueue',
  UserExternalTransferSuccessful = 'UserExternalTransferSuccessful',
  UserExternalTransferFailed = 'UserExternalTransferFailed',
  UserInternalTransferSuccessful = 'UserInternalTransferSuccessful',
  UserInternalTransferFailed = 'UserInternalTransferFailed',
  StandbyDutyExternalAccepted = 'StandbyDutyExternalAccepted',
}

export const filterableOutcomes = [
  ServerSideOutcome.Handled,
  ServerSideOutcome.WorkflowInternalTransferFailed,
  ServerSideOutcome.WorkflowExternalTransferFailed,
  ServerSideOutcome.WorkflowInternalTransferSuccessful,
  ServerSideOutcome.WorkflowExternalTransferSuccessful,
  ServerSideOutcome.WorkflowConversationRecorded,
  ServerSideOutcome.DeclinedByWorkflowWhenNoQueue,
  ServerSideOutcome.DeclinedByWorkflowAfterQueue,
  HistoryConversationStatus.CustomerHangupInIvrAfterQueue,
  HistoryConversationStatus.HangupBeforeAccept,
  HistoryConversationStatus.HangupInIvr,
  HistoryConversationStatus.HangupInQueue,
  HistoryConversationStatus.Failed,
  HistoryConversationStatus.OutboundTaskDestinationAccepted,
  HistoryConversationStatus.OutboundTaskDestinationDeclined,
  HistoryConversationStatus.OutboundTaskUserAborted,
  HistoryConversationStatus.OutboundTaskDestinationNotReached,
  HistoryConversationStatus.OutboundTaskLostInQueue,
  HistoryConversationStatus.ExternalSystemCancelled,
  HistoryConversationStatus.ExternalSystemCancelledAfterQueue,
  HistoryConversationStatus.ExternalSystemCancelledBeforeAccept,
  HistoryConversationStatus.ExternalSystemCancelledInQueue,
  HistoryConversationStatus.MarkedAsHandledByUser,
  HistoryConversationStatus.MarkedAsHandledByWorkflow,
  ServerSideOutcome.UserExternalTransferFailed,
  ServerSideOutcome.UserExternalTransferSuccessful,
  ServerSideOutcome.UserInternalTransferFailed,
  ServerSideOutcome.UserInternalTransferSuccessful,
  HistoryConversationStatus.StandbyDutyExternalAccepted,
  HistoryConversationStatus.WorkflowCallbackScheduleSuccessful,
];

export const outcomeMetaData: Record<
  keyof typeof ServerSideOutcome | HistoryConversationStatus,
  { translationKey: TranslationKeys; colorId: ChartThemeProperty }
> = {
  AcceptedByUser: { translationKey: TranslationKeys.ChartLabelUserAccepted, colorId: ChartThemeProperty.Handled },
  Handled: { translationKey: TranslationKeys.ChartLabelUserAccepted, colorId: ChartThemeProperty.Handled },
  Failed: { translationKey: TranslationKeys.ChartLabelFailed, colorId: ChartThemeProperty.NotHandled },
  CustomerHangupInIvrAfterQueue: {
    translationKey: TranslationKeys.ChartLabelCustomerHangupInIvrAfterQueue,
    colorId: ChartThemeProperty.HangupInIVRAfterQueue,
  },
  HangupBeforeAccept: {
    translationKey: TranslationKeys.ChartLabelCustomerHangupBeforeAccept,
    colorId: ChartThemeProperty.HangupBeforeAccept,
  },
  HangupByWorkflow: { translationKey: TranslationKeys.ChartLabelHangupByWorkflow, colorId: ChartThemeProperty.HangupByWorkflow },
  HangupInIvr: { translationKey: TranslationKeys.ChartLabelCustomerHangupInIvr, colorId: ChartThemeProperty.HangupInIvr },
  HangupInQueue: {
    translationKey: TranslationKeys.ChartLabelCustomerHangupInQueue,
    colorId: ChartThemeProperty.HangupInQueue,
  },
  TransferFailed: { translationKey: TranslationKeys.ChartLabelTransferFailed, colorId: ChartThemeProperty.TransferFailed },
  WorkflowExternalTransferFailed: {
    translationKey: TranslationKeys.ChartLabelWorkflowExternalTransferFailed,
    colorId: ChartThemeProperty.TransferFailed,
  },
  WorkflowInternalTransferFailed: {
    translationKey: TranslationKeys.ChartLabelWorkflowInternalTransferFailed,
    colorId: ChartThemeProperty.TransferFailed,
  },
  TransferredByWorkflow: {
    translationKey: TranslationKeys.ChartLabelTransferredByWorkflow,
    colorId: ChartThemeProperty.TransferredByWorkflow,
  },
  TransferredByUser: {
    translationKey: TranslationKeys.ChartLabelTransferredByUser,
    colorId: ChartThemeProperty.TransferredByUser,
  },
  WorkflowExternalTransferSuccessful: {
    translationKey: TranslationKeys.ChartLabelWorkflowExternalTransferSuccessful,
    colorId: ChartThemeProperty.TransferredByWorkflow,
  },
  WorkflowInternalTransferSuccessful: {
    translationKey: TranslationKeys.ChartLabelWorkflowInternalTransferSuccessful,
    colorId: ChartThemeProperty.TransferredByWorkflow,
  },
  VoiceMessage: { translationKey: TranslationKeys.ChartLabelVoicemail, colorId: ChartThemeProperty.Voicemail },
  WorkflowConversationRecorded: {
    translationKey: TranslationKeys.ChartLabelConversationRecorded,
    colorId: ChartThemeProperty.Voicemail,
  },
  OutboundTaskDestinationAccepted: {
    translationKey: TranslationKeys.ChartLabelDestinationAccepted,
    colorId: ChartThemeProperty.DestinationAccepted,
  },
  OutboundTaskDestinationDeclined: {
    translationKey: TranslationKeys.ChartLabelDestinationDeclined,
    colorId: ChartThemeProperty.DestinationDeclined,
  },
  DeclinedByWorkflowAfterQueue: {
    translationKey: TranslationKeys.ChartLabelWorkflowDisconnectAfterQueue,
    colorId: ChartThemeProperty.HangupByWorkflow,
  },
  DeclinedByWorkflowWhenNoQueue: {
    translationKey: TranslationKeys.ChartLabelWorkflowDisconnect,
    colorId: ChartThemeProperty.HangupByWorkflow,
  },
  OutboundTaskUserAborted: { translationKey: TranslationKeys.ChartLabelUserAborted, colorId: ChartThemeProperty.UserAborted },
  OutboundTaskDestinationNotReached: {
    translationKey: TranslationKeys.ChartLabelDestinationNotReached,
    colorId: ChartThemeProperty.DestinationNotReached,
  },
  OutboundTaskLostInQueue: { translationKey: TranslationKeys.ChartLabelLostInQueue, colorId: ChartThemeProperty.LostInQueue },
  ExternalSystemCancelled: {
    translationKey: TranslationKeys.UnifiedSessionsOutcomeExternalSystemCancelled,
    colorId: ChartThemeProperty.CanceledByExternalSystem,
  },
  ExternalSystemCancelledAfterQueue: {
    translationKey: TranslationKeys.UnifiedSessionsOutcomeExternalSystemCancelledAfterQueue,
    colorId: ChartThemeProperty.CanceledByExternalSystem,
  },
  ExternalSystemCancelledBeforeAccept: {
    translationKey: TranslationKeys.UnifiedSessionsOutcomeExternalSystemCancelledBeforeAccept,
    colorId: ChartThemeProperty.CanceledByExternalSystem,
  },
  ExternalSystemCancelledInQueue: {
    translationKey: TranslationKeys.UnifiedSessionsOutcomeExternalSystemCancelledInQueue,
    colorId: ChartThemeProperty.CanceledByExternalSystem,
  },
  MarkedAsHandledByUser: {
    translationKey: TranslationKeys.GeneralUserInteractionOutcomeUserMarkedAsHandled,
    colorId: ChartThemeProperty.MarkedAsHandledByUser,
  },
  MarkedAsHandledByWorkflow: {
    translationKey: TranslationKeys.GeneralUserInteractionOutcomeWorkflowMarkedAsHandled,
    colorId: ChartThemeProperty.MarkedAsHandledByWorkflow,
  },
  UserExternalTransferSuccessful: {
    translationKey: TranslationKeys.ChartLabelUserExternalTransferSuccessful,
    colorId: ChartThemeProperty.TransferredByUser,
  },
  UserExternalTransferFailed: {
    translationKey: TranslationKeys.ChartLabelUserExternalTransferFailed,
    colorId: ChartThemeProperty.TransferFailed,
  },
  UserInternalTransferSuccessful: {
    translationKey: TranslationKeys.ChartLabelUserInternalTransferSuccessful,
    colorId: ChartThemeProperty.TransferredByUser,
  },
  UserInternalTransferFailed: {
    translationKey: TranslationKeys.ChartLabelUserInternalTransferFailed,
    colorId: ChartThemeProperty.TransferFailed,
  },
  StandbyDutyExternalAccepted: {
    translationKey: TranslationKeys.ChartLabelStandbyDutyExternalAccepted,
    colorId: ChartThemeProperty.StandbyDutyAccepted,
  },
  WorkflowCallbackScheduleSuccessful: {
    translationKey: TranslationKeys.ChartLabelCallbackScheduleSuccess,
    colorId: ChartThemeProperty.MarkedAsHandledByWorkflow,
  },
};
